let connectionPromise: Promise<IDBDatabase> | undefined;

const BASE_STORE_CONFIG: [any, Array<[string, any]>] = [
  { keyPath: 'keyPath' },
  [
    ['args', {unique: false}],
    ['accountId', {unique: false}],
  ]
];

const version = 7;
const stores: Array<[string, any, Array<[string, any]>]> = [
  ['timesec/access-tokens', {keyPath: 'id'}, []],
  ['store/accounts/institutions/settings', ...BASE_STORE_CONFIG],
  ['store/accounts/institutions/settings-historical', ...BASE_STORE_CONFIG],
  ['store/employees/employees/roles', ...BASE_STORE_CONFIG],
  ['store/employees/employees/settings', ...BASE_STORE_CONFIG],
  ['store/employees/employees/settings-historical', ...BASE_STORE_CONFIG],
  ['store/timestamps/workmonths', ...BASE_STORE_CONFIG],
  ['store/reports/employees', ...BASE_STORE_CONFIG],
//  ['store/institutions', {keyPath: 'id'}, []],
];

function getConnection(): Promise<IDBDatabase> {
  if (connectionPromise) return connectionPromise;

  connectionPromise = new Promise<IDBDatabase>((resolve, reject) => {
    const request = window.indexedDB.open('zeit-db', version);

    request.onupgradeneeded = () => {
      const db = request.result;
      for (const [name, storeConfig, indexes] of stores) {
        if (db.objectStoreNames.contains(name)) continue;
        const objectStore = db.createObjectStore(name, storeConfig);
        for (const [index, indexConfig] of indexes) objectStore.createIndex(index, index, indexConfig);
      }
    };

    request.onsuccess = () => {
      const db = request.result;
      db.onclose = () => { connectionPromise = undefined; };
      db.onversionchange = () => { db.close(); connectionPromise = undefined; };
      resolve(db);
    };

    request.onerror = () => {
      connectionPromise = undefined;
      reject(request.error ?? new Error('Cannot open indexedDB connection'));
    };

    request.onblocked = () => {
      connectionPromise = undefined;
      reject(request.error ?? new Error('indexedDB open blocked'));
    };
  });

  return connectionPromise;
}

async function getEntries<T>(objectStore): Promise<Array<T>> {
  const connection = await getConnection();
  const store = connection.transaction(objectStore).objectStore(objectStore);

  return new Promise(resolve => {
    const entries: Array<T> = [];
    store.openCursor().onsuccess = (event) => {
      const cursor = (event.target as IDBRequest<T>).result;
      if (!cursor) return;
      entries.push(cursor.value);
      cursor.continue;
    };
    resolve(entries);
  });
}

async function getEntry<T>(objectStore, id): Promise<T> {
  const connection = await getConnection();
  const store = connection.transaction(objectStore).objectStore(objectStore);
  const request = store.get(id);

  return new Promise(resolve => {
    request.onsuccess = () => resolve(request.result);
  });
}

function deleteEntry(objectStore, id): Promise<undefined> {
  return new Promise(resolve => {
    getConnection().then(connection => {
      const t = connection.transaction(objectStore, 'readwrite');
      t.objectStore(objectStore).delete(id);
      t.oncomplete = () => resolve(undefined);
    });
  });
}

function putEntry<T>(objectStore, entry: T): Promise<undefined> {
  return new Promise(resolve => {
    getConnection().then(connection => {
      const t = connection.transaction(objectStore, 'readwrite');
      t.objectStore(objectStore).put(entry);
      t.oncomplete = () => resolve(undefined);
    });
  });
}

export { getEntries, getEntry, deleteEntry, putEntry };
